import * as React from "react";
import { inject, observer } from "mobx-react";
import AccountService, {
  SubscriptionPlan,
  userTypes,
} from "../../service/AccountService";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Paper,
  Card,
  CardActionArea,
  CardActions,
  ListItem,
  ListItemText,
  List,
  ListItemIcon,
  Button,
  IconButton,
} from "@mui/material";
import LogoutButton from "../common/LogoutButton";
import autobind from "autobind-decorator";
import DoneIcon from "@mui/icons-material/Done";
import BackIcon from "@mui/icons-material/ArrowBack";
import { RouterStore } from "mobx-react-router";
import { Stripe, StripeElements } from "@stripe/stripe-js";
import { ElementsConsumer } from "@stripe/react-stripe-js";
import { styled } from "@mui/material/styles";
import firebase from "firebase/compat/app";
import { withStyles } from "@mui/styles";

const PlanPricing: Array<SubscriptionPlan> = [
  {
    id: 1001,
    name: "Personal Pack",
    type: "BASIC",
    price: 0,
    features: [
      "1 Flow Chart, Smart Questionnaire Form, Dynamic Survey",
      "5 Uses and Responses",
      "1 Location",
    ],
  },
  {
    id: 1002,
    name: "Business Class",
    type: "STANDARD",
    price: 25,
    features: [
      "Up to 3 Flow Charts, Smart Questionnaire Forms, Workflows, Dynamic Survey, Website Chat Bots",
      "Unlimited Uses and Responses",
      "Up to 3 Locations",
      "Send Unlimited Surveys by Text Message/Email/Web ChatBot",
    ],
  },
  {
    id: 1003,
    name: "Premium",
    type: "PREMIUM",
    price: 50,
    features: [
      "Unlimited Flow Charts, Smart Questionnaire Forms, Workflows, Dynamic Survey, Website Chat Bots",
      "Unlimited Uses and Responses",
      "Unlimited Locations",
      "Send Unlimited Surveys by Text Message/Email/Web ChatBot",
    ],
  },
];

const testPlans = {
  businessClassPlanId: "price_1MD8ApKasdCyPLOaZhfNkglO",
  premiumPlanId: "price_1MDsm7KasdCyPLOakXwrB3QM",
};
const livePlans = {
  businessClassPlanId: "price_1JV28XKasdCyPLOaCmqYv8ff",
  premiumPlanId: "price_1JV28zKasdCyPLOaFnw6vVz5",
};

const PlanType = withStyles({
  root: {
    fontWeight: 500,
    color: "#323D48",
    "&.MidCard": {
      color: "#FFF",
    },
  },
})(Typography);

const FeatureText = withStyles({
  root: {
    color: "#333B49",
    "&.MidCard": {
      color: "#FFF",
    },
  },
})(ListItemText);

const PerMonth = withStyles({
  root: {
    display: "flex",
    color: "#00A2ED",
    alignItems: "flex-end",
    "&.MidCard": {
      color: "#FFF",
    },
  },
})(Typography);

const PriceTypo = withStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    justifyContent: "center",
    color: "#00A2ED",
    fontSize: "42px",
    fontWeight: "bolder",
    fontStyle:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    borderBottomStyle: "solid",
    borderBottomWidth: "1px",
    borderBottomColor: "#d6d3d3",
    paddingBottom: "20px",
    "&.MidCard": {
      color: "#FFF",
    },
  },
})(Typography);

const BuyButton = withStyles({
  root: {
    height: "60px",
    padding: "10px 30px",
    // borderStyle: 'solid',
    // borderColor: '#00A2ED',
    borderRadius: "40px",
    // borderWidth: '1px',
    backgroundColor: "#FFF",
    "&:hover": {
      backgroundColor: "#00A2ED",
      color: "#FFF",
    },
  },
  label: {
    fontWeight: "bold",

    color: "#00A2ED",
    "&:hover": {
      color: "#FFF",
    },
  },
})(Button);

const Tick = withStyles({
  root: {
    color: "#2BCE24",
    "&.MidCard": {
      color: "#FFF",
    },
  },
})(DoneIcon);

const PlanCard = withStyles({
  root: {
    margin: "20px",
    padding: "30px",
    minWidth: "200px",
    textAlign: "center",
    borderRadius: "15px",
    "&:hover": {
      backgroundColor: "#E6FBFB",
    },
    "&.MidCard": {
      backgroundColor: "#00A2ED",
    },
  },
})(Card);

const CardContainer = styled(Container)({
  marginTop: "36px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  padding: "20px",
  "@media screen and (max-width: 780px)": {
    flexDirection: "column",
    padding: "10px",
    marginTop: "30px",
  },
});

export type PlanPageProps = {
  account?: AccountService;
  routing?: RouterStore;
  stripe: Stripe;
};

type PlanPageState = {
  prices: any[];
};

@inject("routing")
@inject("account")
@observer
class PlanPage extends React.Component<PlanPageProps, PlanPageState> {
  state: PlanPageState = {
    prices: [],
  };

  @autobind
  goBack() {
    var { account } = this.props;
    account.goBack();
  }

  async buyPlan(planId: number) {
    const { account } = this.props;
    let plan = PlanPricing.find((item) => item.id == planId);
    await account.setUserChosenPlan(plan);
    const { stripe } = this.props;

    if (account.user === null) {
      this.props.routing.push("/signup");
    } else {
      if (!stripe) {
        // Stripe.js has not yet loaded.
        // Make  sure to disable form submission until Stripe.js has loaded.
        return;
      }
      await clientCheckoutStripe(
        stripe,
        account.user.email,
        account.userChosenPlan.type,
        account
      );
      //this.props.routing.push('/buyPlan');
    }
  }
  async componentDidMount() {
    const fetchData = await firebase.firestore().collection("prices").get();
    const prices = fetchData.docs.map((item) => item.data());
    this.setState({
      prices: prices,
    });
  }

  renderContents() {
    const { prices } = this.state;
    const { stripe } = this.props;
    return (
      <>
        {this.state.prices.length > 0 && (
          <React.Fragment>
            {PlanPricing.map((plan, i) => (
              <PlanCard key={i} className={i == 1 ? "MidCard" : ""}>
                <CardActionArea>
                  <PlanType
                    gutterBottom
                    variant="h5"
                    className={i == 1 ? "MidCard" : ""}
                  >
                    {plan.name}
                  </PlanType>
                  <PriceTypo gutterBottom className={i == 1 ? "MidCard" : ""}>
                    <span
                      style={{
                        textDecoration: "line-through",
                        marginRight: "10px",
                      }}
                    >
                      {`${i > 0 ? "$" + prices[i - 1]?.sellingPrice : ""}`}
                    </span>
                    {`  $${i > 0 ? prices[i - 1]?.markedPrice : plan.price}`}
                    <PerMonth
                      variant="body2"
                      className={i == 1 ? "MidCard" : ""}
                    >
                      /Month
                    </PerMonth>
                  </PriceTypo>
                  {i > 0 ? (
                    <p style={{ color: `${i == 1 ? "#fff" : "#000"}` }}>
                      Cancel Anytime
                    </p>
                  ) : (
                    ""
                  )}
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="div"
                  >
                    <List>
                      {plan.features.map((item, j) => (
                        <ListItem key={j}>
                          <FeatureText className={i == 1 ? "MidCard" : ""}>
                            <ListItemIcon style={{ minWidth: "24px" }}>
                              <Tick
                                fontSize="small"
                                className={i == 1 ? "MidCard" : ""}
                              />
                            </ListItemIcon>
                            {item}
                          </FeatureText>
                        </ListItem>
                      ))}
                    </List>
                  </Typography>
                </CardActionArea>
                <CardActions style={{ justifyContent: "center" }}>
                  {plan.price > 0 ? (
                    <BuyButton
                      variant="contained"
                      color="secondary"
                      onClick={() => this.buyPlan(plan.id)}
                    >
                      Get Started!
                    </BuyButton>
                  ) : (
                    <BuyButton
                      variant="contained"
                      color="secondary"
                      onClick={this.goBack}
                    >
                      Get Started!
                    </BuyButton>
                  )}
                </CardActions>
              </PlanCard>
            ))}
          </React.Fragment>
        )}
      </>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            width: "100%",
            height: "env(safe-area-inset-top)",
            backgroundColor: "#3f51b5",
          }}
        />
        <AppBar position="static">
          <Toolbar variant="dense">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={this.goBack}
            >
              <BackIcon />
            </IconButton>
            <Typography variant="h6" style={{ flexGrow: 1, color: "inherit" }}>
              Subscription Plans
            </Typography>
            {this.props.account.user ? <LogoutButton /> : null}
          </Toolbar>
        </AppBar>
        <CardContainer maxWidth="xl">
          {this.state.prices.length > 0 && this.renderContents()}
        </CardContainer>
      </React.Fragment>
    );
  }
}

export default function InjectedPlanPage() {
  return (
    <ElementsConsumer>
      {({ stripe }) => <PlanPage stripe={stripe} />}
    </ElementsConsumer>
  );
}

async function clientCheckoutStripe(
  stripe: Stripe,
  email: string,
  plan: string,
  account: AccountService
) {
  let planId: string;
  let planType: string;
  if (plan === "STANDARD") {
    //planId = testPlans.businessClassPlanId;
    planId = livePlans.businessClassPlanId;
    planType = userTypes.STANDARD_USER;
  } else if (plan === "PREMIUM") {
    //planId = testPlans.premiumPlanId;
    planId = livePlans.premiumPlanId;
    planType = userTypes.PREMIUM_USER;
  }

  await stripe.redirectToCheckout({
    items: [{ plan: planId, quantity: 1 }],
    successUrl: `http://${window.location.host}/planSuccess/session_id={CHECKOUT_SESSION_ID}`,
    cancelUrl: `http://${window.location.host}/planFail`,
    customerEmail: email,
  });
}

async function saveUserTypeChange(planType: string, account: AccountService) {
  const userId = account.user.uid;
  let message: string;
  const result = await account.updateUserType(userId, planType);
  if (result === "SUCCESS") {
    message = "SUCCESS: Updated User type!";
  } else {
    message = result.toString();
  }
}
